import * as React from 'react';
import s from './Group.scss';
import { FeatureRow } from './FeatureRow';
import { useTranslation } from 'react-i18next';
import { Text } from 'wix-style-react';
import { AdvancedPlansProductData, FeaturesGroupSection } from 'types';
import { ReactComponent as PaidOnlineBusinessLogo } from '../../../../assets/images/groups-icons/get-paid-online-business.svg';
import { ReactComponent as GrowYourOnlinePresenceWebsite } from '../../../../assets/images/groups-icons/grow-your-online-presence-website.svg';
import { ReactComponent as LookProfessionalBusiness } from '../../../../assets/images/groups-icons/look-professional-business.svg';
import { ReactComponent as LookProfessionalWebsite } from '../../../../assets/images/groups-icons/look-professional-website.svg';
import { ReactComponent as PromoteAndGrowYourSiteBusiness } from '../../../../assets/images/groups-icons/promote-and-grow-your-site-business.svg';
import { ReactComponent as PromoteYourBrandWebsite } from '../../../../assets/images/groups-icons/promote-your-brand-website.svg';

interface GroupProps {
  products: AdvancedPlansProductData[];
  group: FeaturesGroupSection;
}

const logos = {
  'get-paid-online-business': <PaidOnlineBusinessLogo />,
  'grow-your-online-presence-website': <GrowYourOnlinePresenceWebsite />,
  'look-professional-business': <LookProfessionalBusiness />,
  'look-professional-website': <LookProfessionalWebsite />,
  'promote-and-grow-your-site-business': <PromoteAndGrowYourSiteBusiness />,
  'promote-your-brand-website': <PromoteYourBrandWebsite />,
};

export const Group: React.FC<GroupProps> = ({ group, products }) => {
  const { t } = useTranslation();
  return (
    <div className={s.groupWrapper}>
      <div className={s.groupHeader}>
        {logos[group.icon]}
        <Text weight='bold'>{t(group.translationKey)}</Text>
      </div>
      <div className={s.groupSubgrid}>
        {group.features.map((feature, idx) => (
          <FeatureRow
            key={idx}
            products={products}
            feature={feature}
            cellClassName={s.groupCell}
          />
        ))}
      </div>
    </div>
  );
};
